export const exports = ({ theme }) => ({
    paddingTop: '40px',
    paddingBottom: '40px',
    marginBottom: '17px',

    borderBottomLeftRadius: '6px',
    borderBottomRightRadius: '6px',
});
